import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../lasuite.constants';

@Component({
  selector: 'app-lasuite-change-password-sent',
  templateUrl: './lasuite-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './lasuite-change-password-sent.component.css',
  ],
})
export class LasuiteChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
